/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Ouvre le lien CGV dans une nouvelle fenêtre
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].href == "https://cdn.shopify.com/s/files/1/0607/7979/0524/files/CGV-LEOMI.pdf") {
    links[i].target = '_blank';
	//links[i].rel = 'noreferrer noopener';
  }
}

// Ajoute par mois sur le prix si on est en mode appstle subscription
/*
$( document ).ready(function() {
	console.log($('#appstle_subscription_widget0'));
});
span.product__current-price:after {
    content: " / mois";
}
*/

var areaChild = document.getElementById("blocplusieursenfants");
if(areaChild){
  document.getElementById("plusieursenfants").addEventListener("click", displayAreaChild);
  function displayAreaChild(){
    document.getElementById("blocplusieursenfants").style.display = "block";
    document.getElementById("plusieursenfants").innerHTML = " ";
    document.getElementById("plusieursenfants").removeEventListener("click", displayAreaChild);
    document.getElementById("plusieursenfants").addEventListener("click", undisplayAreaChild);
  }
  function undisplayAreaChild(){
    document.getElementById("blocplusieursenfants").style.display = "none";
    document.getElementById("plusieursenfants").innerHTML = "Je souhaite inscrire plusieurs enfants";
    document.getElementById("plusieursenfants").removeEventListener("click",undisplayAreaChild);
    document.getElementById("plusieursenfants").addEventListener("click", displayAreaChild);
  }
}
 